import { useTranslation } from 'react-i18next';

import { InputTextField } from '@adflow/frontend/ui-form';

interface ColumnTemplateNameEditorProps {
	name?: string;
	setName: (name: string) => void;
	disabled?: boolean;
	readOnly?: boolean;
}

export function ColumnTemplateNameEditor({
	disabled,
	name,
	setName,
	readOnly,
}: ColumnTemplateNameEditorProps) {
	const { t } = useTranslation('common');

	return (
		<InputTextField
			name="name"
			value={name}
			onChange={(e) => {
				setName(e.target.value);
			}}
			placeholder={t('name')}
			type="text"
			autoCompleteOff
			outerStyle={{ width: '100%' }}
			helperStyle={{ minHeight: 0 }}
			disabled={disabled}
			readOnly={readOnly}
		/>
	);
}
